import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Pagination,
} from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";

const Blogs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [blogPosts, setBlogPosts] = useState([]);
  const postsPerPage = 2;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/get-blogs`
        );
        const data = await response.json();
        setBlogPosts(data.blogs);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      }
    };

    fetchBlogs();
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogPosts.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div
      id="blogs"
      style={{
        width: "100%",
        backgroundColor: "aliceblue",
        padding: "100px 0",
        minHeight: "70vh",
      }}
    >
      <Grid
        container
        spacing={4}
        sx={{
          width: "90%",
          margin: "auto",
          paddingBottom: "50px",
        }}
      >
        <Grid item xs={12} data-aos="fade-left">
          <Grid container spacing={4}>
            {currentPosts.map((post, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Paper
                  elevation={6}
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    backgroundColor: "white",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  }}
                >
                  <Box
                    component="img"
                    src={`${process.env.REACT_APP_API_URL}/${post.imageUrl}`}
                    alt={post.title}
                    sx={{
                      flexShrink: 0,
                      width: { xs: "100%", md: "250px" },
                      height: { xs: "200px", md: "250px" },
                      objectFit: "cover",
                    }}
                  />
                  <Box padding={2}>
                    <Typography variant="h6" gutterBottom>
                      {post.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "gray", marginBottom: 1 }}
                    >
                      {post.date} at {post.time}
                    </Typography>
                    <Typography variant="body1">{post.description}</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>

          <Box display="flex" justifyContent="center" mt={4}>
            <Pagination
              count={Math.ceil(blogPosts.length / postsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Blogs;
